import { ConfigColunaXLSX } from '../types/dtos-funcoes-exportacao';

export const configsColunasCoordenadas: ConfigColunaXLSX[] = [
	{ casasDecimais: 4, coluna: 'latitude' },
	{ casasDecimais: 4, coluna: 'longitude' },
	{ casasDecimais: 1, coluna: 'altitude' },
];
